<template>
  <div class="row">
    <div class="col-lg-12 form-group">
      <div class="col-lg-12 form-group">
        <div class="list__subtitle" @click="toggleSublist">
          <h4 class="subtitle__text">{{ subtitle }}</h4>
          <i class="fa fa-arrow-down subtitle__icon"></i>
        </div>
      </div>
      <div v-if="isVisible" class="list__wrapper">
        <slot name="fields"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    subtitle: {
      type: String,
      default: "Характеристики",
    },
    visibilityInitState: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      isVisible: false,
    };
  },
  watch: {
    visibilityInitState: {
      handler(value) {
        this.isVisible = value;
      },
      immediate: true,
    },
  },
  methods: {
    toggleSublist() {
      this.isVisible = !this.isVisible;
    },
  },
};
</script>

<style scoped>
@keyframes list-appearing {
  0% {
    transform: translateY(-2em);
  }
  100% {
    transform: translateY(0);
  }
}

.list__wrapper {
  animation: list-appearing 0.3s;
}

.subtitle__text {
  font-weight: 700;
}

.list__subtitle {
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 0.5em;
}

.list__subtitle:hover,
.list__subtitle:focus {
  opacity: 0.75;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/_shared/features/form/Sublist.vue